import { initialize, ThemeProvider } from '@blockanalitica/ui';
import Router from './router';
import { theme, GlobalStyle } from './theme';

initialize({ intl: { timezone: 'UTC' } });

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Router />
    </ThemeProvider>
  );
}
